var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import CloseIcon from '@material-ui/icons/Close';
import * as React from 'react';
import styled from 'styled-components';
var defaultODModalHeaderProps = {
    headerTopPadding: 44,
    headerBottomPadding: 44,
    closeButtonPadding: 25,
    closeButtonColor: '#bdbdbd',
};
var HeaderContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding-top: ", "px;\n  padding-bottom: ", "px;\n  width: 100%;\n"], ["\n  padding-top: ", "px;\n  padding-bottom: ", "px;\n  width: 100%;\n"])), function (p) { return p.headerTopPadding; }, function (p) { return p.headerBottomPadding; });
var CloseButtonWrapper = styled.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: absolute;\n  right: 0;\n  top: 0;\n  padding: ", "px;\n  color: ", ";\n  cursor: pointer;\n"], ["\n  position: absolute;\n  right: 0;\n  top: 0;\n  padding: ", "px;\n  color: ", ";\n  cursor: pointer;\n"])), function (p) { return p.closeButtonPadding; }, function (p) { return p.closeButtonColor; });
var HeaderTitle = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  width: 100%;\n  text-align: center;\n  color: ", "; // TODO: PRIMARY?\n  font-size: 20px;\n  font-weight: 500;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: normal;\n  letter-spacing: 0.29px;\n"], ["\n  width: 100%;\n  text-align: center;\n  color: ", "; // TODO: PRIMARY?\n  font-size: 20px;\n  font-weight: 500;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: normal;\n  letter-spacing: 0.29px;\n"])), function (p) { return p.titleColor || 'black'; });
export var ODModalHeader = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    var p = __assign(__assign({}, defaultODModalHeaderProps), props);
    var title = p.title, onClose = p.onClose, elProps = __rest(p, ["title", "onClose"]);
    return (React.createElement(HeaderContainer, __assign({}, elProps),
        React.createElement(HeaderTitle, __assign({}, elProps), title || children),
        onClose && (React.createElement(CloseButtonWrapper, __assign({ onClick: onClose }, elProps),
            React.createElement(CloseIcon, null)))));
};
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=ODModalHeader.js.map